import { useState, useCallback } from 'react';

export function useGroupExpansion() {
  const [expandedGroups, setExpandedGroups] = useState(new Set());

  const toggleGroupExpansion = useCallback((group) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(group)) {
        newSet.delete(group);
      } else {
        newSet.add(group);
      }
      return newSet;
    });
  }, []);

  const resetGroupExpansion = useCallback(() => {
    setExpandedGroups(new Set());
  }, []);

  return { expandedGroups, toggleGroupExpansion, setExpandedGroups, resetGroupExpansion };
}
